import React from 'react';
import moment from 'moment';
import { Row, Col } from 'reactstrap';
import { red500, green500, blue500 } from 'material-ui/styles/colors';
import { ListItem, Avatar, IconMenu, MenuItem, IconButton, RaisedButton, Divider } from 'material-ui';

import Alert from 'material-ui/svg-icons/alert/error';
import Close from 'material-ui/svg-icons/content/clear';
import Bus from 'material-ui/svg-icons/maps/directions-bus';
import User from 'material-ui/svg-icons/action/account-circle';
import Message from 'material-ui/svg-icons/communication/chat';
import CheckCircle from 'material-ui/svg-icons/action/check-circle';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';

import * as reportesAction from '../action';
import * as reservasActions from 'modules/reservas/action';

const ReporteRow = ({ reporte, dispatch }) => {
  if (!reporte || !reporte.get) return null;
  const usuario = reporte.get('_usuario');
  const reserva = reporte.get('_reserva');
  if (!usuario || !reserva) return null;
  const solucionar = reporteId => dispatch(reportesAction.solucionar(reporteId));
  const concretarReserva = () => dispatch(reservasActions.concretarReserva(reserva.get('id'), true, reserva.get('viajeId')));
  const cancelarReserva = () => dispatch(reservasActions.cancelarReserva(reserva.get('id'), true));
  return (
    <div>
      <ListItem
        leftAvatar={reporte.get('solucionado') ? <Avatar icon={<CheckCircle />} backgroundColor={green500} /> : <Avatar icon={<Close />} backgroundColor={red500} />}
        disabled
        className="noMargin"
        primaryText={
          <Row className="listIcon p-lr-10">
            <Col md="2">
              <Row>
                <Col md="1">
                  <Bus />
                </Col>
                <Col md="9" className="mt-5">
                  {moment(reserva.get('horarioViaje')).format('DD/MM HH:mm')}
                </Col>
              </Row>
            </Col>
            <Col md="2">
              <Row>
                <Col md="1">
                  <User color={blue500} />
                </Col>
                <Col md="9" className="mt-5">
                  {usuario.get('nombre')} {usuario.get('apellido')}
                </Col>
              </Row>
            </Col>
            <Col md="4">
              <Row>
                <Col md="1">{reporte.get('viajo') ? <CheckCircle color={green500} /> : <Alert color={red500} />}</Col>
                <Col md="10" className="mt-5">
                  Dijo que <b>{reporte.get('viajo') ? 'VIAJO' : 'NO VIAJO'}</b>
                </Col>
              </Row>
              {reporte.get('viajo') && (
                <Row>
                  <Col md="1">{reserva.get('concretada') ? <CheckCircle color={green500} /> : <Alert color={red500} />}</Col>
                  <Col md="10" className="mt-5">
                    Reserva {reserva.get('concretada') ? 'concretada' : 'no concretada'}
                  </Col>
                </Row>
              )}
              {!reporte.get('viajo') && (
                <Row>
                  <Col md="1">{reserva.get('cancelada') ? <CheckCircle color={green500} /> : <Alert color={red500} />}</Col>
                  <Col md="10" className="mt-5">
                    Reserva {reserva.get('cancelada') ? 'cancelada' : 'no cancelada'}
                  </Col>
                </Row>
              )}
            </Col>
            <Col md="2">
              <RaisedButton primary className="fullWidthComponent noPadding" label="Concretar" disabled={reserva.get('concretada')} onTouchTap={() => concretarReserva()} />
              <RaisedButton
                label="Cancelar"
                className="fullWidthComponent noPadding"
                labelColor="white"
                backgroundColor={red500}
                disabled={reserva.get('cancelada')}
                onTouchTap={() => cancelarReserva()}
              />
            </Col>
            <Col md="2">
              <RaisedButton primary className="fullWidthComponent noPadding" disabled={reporte.get('solucionado')} label="Solucionado" onTouchTap={() => solucionar(reporte.get('id'))} />
            </Col>
          </Row>
        }
        secondaryText={
          reporte.get('comentario') && (
            <Row className="listIcon p-lr-10 mt-10">
              <Col md="1">
                <Message />
              </Col>
              <Col md="11" className="mt-5">
                {reporte.get('comentario')}
              </Col>
            </Row>
          )
        }
      />
      <Divider />
    </div>
  );
};

export default ReporteRow;



// WEBPACK FOOTER //
// src/modules/reportes/components/reporteRow.js